import {
  addIssueToContext,
  INVALID,
  ParseInput,
  ParseReturnType,
  ParseStatus,
  ZodIssueCode,
  ZodParsedType,
  ZodType,
} from 'zod'

class ZodDate extends ZodType<Date, object, string> {
  _parse(input: ParseInput): ParseReturnType<Date> {
    if (typeof input.data !== 'string') {
      const ctx = this._getOrReturnCtx(input)
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: ctx.parsedType,
      })
      return INVALID
    }

    const status = new ParseStatus()

    if (!input.data.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{0,6})?Z$/)) {
      const ctx = this._getOrReturnCtx(input)
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_string,
        validation: 'datetime',
        message: 'Wrong date format',
      })
      return INVALID
    }

    return { status: status.value, value: new Date(input.data) }
  }
}

export const zodDate = () => new ZodDate({})
